import { render, staticRenderFns } from "./CTACall.vue?vue&type=template&id=585ebcb8&scoped=true"
import script from "./CTACall.vue?vue&type=script&lang=js"
export * from "./CTACall.vue?vue&type=script&lang=js"
import style0 from "./CTACall.vue?vue&type=style&index=0&id=585ebcb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ebcb8",
  null
  
)

export default component.exports